/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { labels } from '@umati/dashboard-common';
import StatusTimeline from '../timeline/StatusTimeline';

class TvViewCard extends Component {
  render () {
    return (
      <div className="col-xl-4 col-lg-6">
        {
          this.props.machine &&
          <div className="card card-tv">
            <div className="card-header">
              {this.props.machine.Data.Model && this.props.machine.Data.Model.text}
            </div>
            <div className="card-body">
              <p>
                <b>{labels.manufacturer}</b> {this.props.machine.Data.Manufacturer && this.props.machine.Data.Manufacturer.text}
              </p>
              <StatusTimeline namespaceUri={this.props.machine.MachineId} />
            </div>
          </div>
        }
      </div>
    );
  }
}

class TvViewMachineGrid extends Component {
  render () {
    return (
      <div className="view-tvview">
        <div className="tv-header">
          <div className="container-max">
            <div className="row align-items-center">
              <div className="col-8">
                <h1>{labels.overallState}</h1>
                <h3>{labels.subtitleTvViewMachineGrid}</h3>
              </div>
              <div className="col-4">
                <div className="logo" />
              </div>
            </div>
          </div>
        </div>
        {this.getMachinesRaster()}
      </div>
    );
  }

  getMachinesRaster () {
    return (
      <div className="container-max">{
        this.props?.machines &&
        <div>
          <div className="row mb-4">
            {this.props.machines.map(
              (machine) => <TvViewCard key={machine.MachineId} machine={machine} />
            )}
          </div>
        </div>
      }
      </div>);
  }
}

export default TvViewMachineGrid;
